import { notification, SelectProps } from "antd";
import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "../Components/Dashboard/Dashboard";
import PracticeDetails from "../Components/Practices/PracticeDetails";
import Updates from "../Components/Updates/Updates";
import CTConfiguration from "../Components/CTConfiguration/CTConfiguration";
import PayrollYearlySettings from "../Components/PayrollYearlySettings/PayrollYearlySettings";
import PayrollYearlySettingsDetails from "../Components/PayrollYearlySettings/PayrollYearlySettingsDetails";
import SA100Configuration from "../Components/SA100Configuration/SA100Configuration";
// import ApplicationConfigKey from "../Components/AppConfigKey/ApplicationConfigKey";
import AdminUsers from "../Components/Users/AdminUsers";
import UserProfile from "../Components/Users/UserProfile";
import { getCountries } from "./CommonComponent";
import { useUser } from "../Context/UserContext";
import Holidays from "../Components/Holidays/Holidays";
import SubmissionHoldList from "../Components/SubmissionHold/SubmissionHoldList";
import GeneralSettingsBooks from "../Components/GeneralSettingsBooks/GeneralSettingsBooks";
import Practices from "../Components/Practices/Practices";
import AOTicketDashboard from "../Components/Tickets/AOTicketDashboard";
import TicketDetails from "../Components/Tickets/Details";
import PageNotFound from "./PageNotFound";
import TicketAlertTemplatesList from "../Components/TicketAlertTemplates/TicketAlertTemplatesList";
import SuperAdminLog from "../Components/SuperAdminLog/SuperAdminLog";
import FyiImportList from "../Components/FyiImport/FyiImportList";
import XcelifyExtraction from "../Components/XcelifyExtraction/XcelifyExtraction";
import BiometricReports from "../Components/Reports/BiometricReports";
import AMLReports from "../Components/Reports/AMLReports";
import PracticeDataRequests from "../Components/Practices/PracticeDataRequests";
import PracticeDataRequestDetails from "../Components/Practices/PracticeDataRequestDetails";

export const adminContext = React.createContext<any>(null);

const PageRoute: React.FC = () => {
  type NotificationType = "success" | "info" | "warning" | "error";
  const {
    isAuthenticated,
    isSuperAdmin,
    isSubAdmin,
    isSupportUser,
    isSupportManager,
    isSupportAdmin,
    isSupport,
  } = useUser();
  const hasSupportAccess = () =>
    isSubAdmin() ||
    isSuperAdmin() ||
    isSupportUser() ||
    isSupportManager() ||
    isSupportAdmin() ||
    (isSupport && isSupport());
  const isOnlySupport = () =>
    (isSupportUser() ||
      isSupportManager() ||
      isSupportAdmin() ||
      (isSupport && isSupport())) &&
    !isSuperAdmin() &&
    !isSubAdmin();
  const [practiceData, setPracticeData] = React.useState<any>(undefined);
  const [payrollYearlySettingsData, setPayrollYearlySettingsData] =
    React.useState<any>(undefined);
  const [api, contextHolder] = notification.useNotification();
  const [countriesOptions, setCountriesOptions] = React.useState<
    SelectProps["options"]
  >([]);
  const openNotification = (
    type: NotificationType,
    message: string | undefined,
  ) => {
    api[type]({
      message: "",
      description: message,
      duration: 4,
      style: {
        width: 400,
        top: 18,
        borderRadius: 0,
        padding: "20px 12px",
      },
    });
  };

  const location = useLocation();

  React.useEffect(() => {
    getCountriesOptions();
  }, []);

  const getCountriesOptions = async () => {
    const COptions: SelectProps["options"] = [];
    var countries: any = await getCountries();
    if (countries) {
      let Count = countries?.map((item: any) => {
        COptions.push({
          label: item?.name,
          value: item?.id,
        });
        return item;
      });
      if (Count.length > 0) setCountriesOptions(COptions);
      // return countriesOptions1;
    }
  };

  React.useEffect(() => {
    const path = location.pathname;
    let title = "Acting Office";
    switch (true) {
      case path.startsWith("/dashboard"):
        title = `Dashboard - ${title}`;
        break;
      case path.startsWith("/practices"):
        title = `Practices - ${title}`;
        break;
      case path.startsWith("/updates"):
        title = `Updates - ${title}`;
        break;
      case path.startsWith("/holidays"):
        title = `Holidays - ${title}`;
        break;
      case path.startsWith("/ctconfiguration"):
        title = `CTConfiguration - ${title}`;
        break;
      case path.startsWith("/payrollyearlysettings"):
        title = `Payroll Yearly Settings - ${title}`;
        break;
      case path.startsWith("/ApplicationConfigKey"):
        title = `Application ConfigKey - ${title}`;
        break;
      case path.startsWith("/submissionhold"):
        title = `Submission Hold - ${title}`;
        break;
      case path.startsWith("/generalsettingbooks"):
        title = `General Settings Books - ${title}`;
        break;
      case path.startsWith("/adminusers"):
        title = `Admin Users - ${title}`;
        break;
      case path.startsWith("/adminuser"):
        title = `Profile - ${title}`;
        break;
      case path.startsWith("/tickets"):
        title = `Support tickets - ${title}`;
        break;
      case path.startsWith("/fyi-import"):
        title = `FYI Bulk Import - ${title}`;
        break;
      case path.startsWith("/ticket-alert-templates"):
        title = `Ticket alert templates - ${title}`;
        break;
      case path.startsWith("/xcelify-extraction"):
        title = `Xcelify Extraction - ${title}`;
        break;
      default:
        title = `Acting Office`;
    }
    document.title = title;
  }, [location]);

  return (
    <adminContext.Provider
      value={{
        openNotification,
        countriesOptions,
        practiceData,
        setPracticeData,
        payrollYearlySettingsData,
        setPayrollYearlySettingsData,
      }}
    >
      <Routes>
        {isAuthenticated() && (isSuperAdmin() || isSupportAdmin()) && (
          <>
            <Route path="/adminusers" element={<AdminUsers />} />
          </>
        )}
        {isAuthenticated() && isSuperAdmin() && (
          <>
            <Route
              path="/sa100configuration"
              element={<SA100Configuration />}
            />
            <Route path="/submissionhold" element={<SubmissionHoldList />} />
            <Route
              path="/generalsettingbooks"
              element={<GeneralSettingsBooks />}
            />
            <Route path="/fyi-import" element={<FyiImportList />} />
            <Route path="/xcelify-extraction" element={<XcelifyExtraction />} />
            <Route
              path="/practice-data-requests"
              element={<PracticeDataRequests />}
            />
            <Route
              path="/practice-data-requests/:id"
              element={<PracticeDataRequestDetails />}
            />

            {/* <Route path="/ApplicationConfigKey" element={<ApplicationConfigKey />} /> */}
            {/* <Route path="/userAuditLog" element={<AllUserAuditLog />} /> */}
          </>
        )}
        {isAuthenticated() && hasSupportAccess() && (
          <>
            {/* <Route path="/profile" element={<Profile />} /> */}
            <Route
              path="/"
              element={
                isOnlySupport() ? (
                  <Navigate to="/tickets" replace />
                ) : (
                  <Dashboard />
                )
              }
            />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/practices" element={<Practices />} />
            <Route
              path="/practices/:id"
              element={<PracticeDetails data={practiceData} />}
            />
            <Route path="/adminuser/profile/:id" element={<UserProfile />} />
            <Route path="/updates" element={<Updates />} />
            <Route path="/tickets" element={<AOTicketDashboard />} />
            <Route path="/tickets/:id" element={<TicketDetails />} />
            <Route path="/holidays" element={<Holidays />} />
            <Route path="/ctconfiguration" element={<CTConfiguration />} />
            <Route
              path="/payrollyearlysettings"
              element={<PayrollYearlySettings />}
            />
            <Route
              path="/payrollyearlysettings/:id"
              element={
                <PayrollYearlySettingsDetails
                  data={payrollYearlySettingsData}
                />
              }
            />
            <Route
              path="/ticket-alert-templates"
              element={<TicketAlertTemplatesList />}
            />
            <Route path="/super-admin-logs" element={<SuperAdminLog />} />
            <Route path="/biometric-report" element={<BiometricReports />} />
            <Route path="/aml-report" element={<AMLReports />} />
            <Route path="*" element={<PageNotFound />} />
          </>
        )}
      </Routes>
      {contextHolder}
    </adminContext.Provider>
  );
};
export default PageRoute;
